import React from 'react';
import { Steps } from 'antd';
import { map } from 'lodash';

const { Step } = Steps;

import './stepper.scss';
import classNames from "classnames";

interface Step {
  label: string;
  isDisabled?: boolean;
  component: React.ReactNode;
}

export interface StepperProps {
  steps: Step[];
  activeKey: number;
  size: 'default' | 'small';
  [key: string]: any;
}

export const Stepper = ({ steps, activeKey, size = 'default', ...props }: StepperProps) => {
  return (
    <div className={classNames('stepper', props.className)}>
      <Steps current={activeKey || 0} size={size} {...props}>
        {steps.map((step, index) => {
          return (
              <Step title={step.label} key={index} disabled={step.isDisabled}></Step>
          )
        })}
      </Steps>
      <div className="steps-content">{steps[activeKey].component}</div>
    </div>
  )
}
